import { fmt } from "@/components/states";

// PATCH 37 Mi15 — relative time ("2 hours ago") with the exact timestamp on hover, everywhere.
export default function RelTime({ value, testid }) {
  if (!value) return <span className="k-muted">—</span>;
  return (
    <time data-testid={testid} dateTime={new Date(value).toISOString?.() || undefined}
      title={fmt.datetime(value)} className="k-muted">
      {fmt.rel(value)}
    </time>
  );
}
